import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { Component } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { s as styleInputMixin } from '../InputFormGroup/InputFormGroup.styles-BnvMUk21.js';
import { I as Icon } from '../Icon/Icon-rcwnFk3r.js';
import { r as search, t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { B as Button } from '../Button/Button-Cv4kr51v.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { T as Text } from '../Text/Text-ZAmghSXE.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';

const NodeSafeInputElement = typeof HTMLInputElement !== 'undefined' ? HTMLInputElement : Object;
const SearchInputWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-30065889__sc-no5occ-0"
})(["gap:2px;&&{background-color:", ";}"], ({
  theme,
  $disabled
}) => $disabled ? theme.form.input.disabled.bg : theme.form.input.bg);
const StyledSearch = /*#__PURE__*/styled(({
  hideLabel,
  ...rest
}) => /*#__PURE__*/React__default.createElement(Icon, _extends({
  type: search
}, rest))).withConfig({
  componentId: "sc-storm-ui-30065889__sc-no5occ-1"
})(["font-size:", ";opacity:", ";color:", ";margin-inline-end:", ";display:flex;", ""], ({
  theme
}) => theme.form.search.searchIconFontSize, ({
  theme
}) => theme.form.search.searchIconOpacity, ({
  theme
}) => theme.form.search.searchIconColor, ({
  theme
}) => theme.form.search.searchIconMarginRight, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.form.search.mobile.searchIconFontSize)));
StyledSearch.displayName = 'StyledSearch';
const StyledClose = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30065889__sc-no5occ-2"
})(["font-size:", ";background:none;border:none;box-shadow:none;color:", ";margin:", ";padding:", ";border-radius:", ";:hover{color:", ";background:none;box-shadow:none;}& span{display:flex;}", ""], ({
  theme
}) => theme.form.search.closeButtonFontSize, ({
  theme
}) => theme.form.search.closeButtonColor, ({
  theme
}) => theme.form.search.closeButtonMargin, ({
  theme
}) => theme.form.search.closeButtonPadding, ({
  theme
}) => theme.form.search.closeButtonBorderRadius, ({
  theme
}) => theme.form.search.closeButtonColorHover, isMobile(css(["font-size:", ";position:absolute;padding:", ";left:auto;inset-inline-start auto;right:0;inset-inline-end:0;[dir=\"rtl\"] &&{right:auto;inset-inline-start auto;left:0;inset-inline-end:0;}"], ({
  theme
}) => theme.form.search.mobile.closeButtonFontSize, ({
  theme
}) => theme.form.search.mobile.closeButtonPadding)));
StyledClose.displayName = 'StyledClose';
const CloseIcon = withTaktFallbackId(StyledClose);
class SearchInputElement extends Component {
  render() {
    const {
      className,
      value,
      onChange,
      onClear,
      clearBtnProps,
      clearButtonLabel,
      inputRef,
      disabled,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(SearchInputWrapper, {
      $disabled: disabled,
      className: className
    }, /*#__PURE__*/React__default.createElement(StyledSearch, null), /*#__PURE__*/React__default.createElement("input", _extends({}, rest, {
      disabled: disabled,
      value: value,
      onChange: onChange,
      ref: inputRef
    })), value && /*#__PURE__*/React__default.createElement(CloseIcon, _extends({}, clearBtnProps, {
      type: "button",
      onClick: onClear,
      "aria-label": clearButtonLabel,
      disabled: disabled,
      taktFallbackId: createStormTaktId('close-button')
    }), /*#__PURE__*/React__default.createElement(Icon, {
      type: times
    }), /*#__PURE__*/React__default.createElement(Text, {
      type: "sr-only"
    }, clearButtonLabel)));
  }
}
_defineProperty(SearchInputElement, "propTypes", {
  className: PT.string.isRequired,
  value: PT.string.isRequired,
  onChange: PT.func.isRequired,
  onClear: PT.func.isRequired,
  clearBtnProps: PT.objectOf(PT.any),
  clearButtonLabel: PT.string,
  inputRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(NodeSafeInputElement)
  })]),
  disabled: PT.bool
});
_defineProperty(SearchInputElement, "defaultProps", {
  clearBtnProps: {},
  clearButtonLabel: 'Clear search terms',
  inputRef: () => null,
  disabled: false
});
const SearchInputComponent = /*#__PURE__*/styled(SearchInputElement).withConfig({
  componentId: "sc-storm-ui-30065889__sc-no5occ-3"
})(["display:flex;align-items:center;min-height:calc(", " - 6px);> input{", " flex :1 1 auto;padding:0;border-style:none;-webkit-appearance:none;min-width:1em;:focus{outline:none;box-shadow:none;border:none;}height:100%;min-height:auto;box-shadow:none;border:none;}"], ({
  theme
}) => theme.form.input.height, styleInputMixin);

export { SearchInputComponent as S };
//# sourceMappingURL=SearchInputComponent-4gu7ZCQO.js.map
